import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	export: {
		id: 'business-timeline.timeline-view.export-image.export',
		defaultMessage: 'Export',
		description: 'Button label to open modal for exporting timeline as an image',
	},
});
